import assetsPathConfig from '../constants/assetsPath'
import { isProduction } from './envHelper'

export default () => {
  if (isProduction()) {
    return assetsPathConfig.production
  }
  return assetsPathConfig.development
}



// WEBPACK FOOTER //
// ./common/utils/assetsPath.js